import React from "react";

import Alert, { AlertProps } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import styled from "@mui/material/styles/styled";

interface SystemToastProps extends AlertProps {
  type: "system";
  title?: string;
}

interface StandardToastProps extends AlertProps {
  type?: "default";
}

export type ToastProps = SystemToastProps | StandardToastProps;

const SystemAlertAction = styled("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (_props, styles) => styles.action,
})({
  display: "flex",
  alignItems: "flex-start",
  marginLeft: "-8px",
});

const Toast = React.forwardRef(
  ({ type = "default", ...props }: ToastProps, ref) => {
    if (type === "system") {
      const { action, children, title, ...rest } = props;
      return (
        <Alert
          variant="outlined"
          sx={{ maxWidth: "410px" }}
          {...rest}
          ref={(el) =>
            typeof ref === "function" ? ref(el) : ref && (ref.current = el)
          }
        >
          <Stack>
            {title ? <AlertTitle>{title}</AlertTitle> : null}
            <Box sx={{ paddingBottom: "4px" }}>{children}</Box>
            {action && (
              // ownerState isn't exposed in the mui types for some reason.
              // so... gonna just suppress the error here for now
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore-next-line
              <SystemAlertAction ownerState={{ variant: "outlined", ...rest }}>
                {action}
              </SystemAlertAction>
            )}
          </Stack>
        </Alert>
      );
    }
    return (
      <Alert
        variant="filled"
        sx={{ maxWidth: "100vw" }}
        {...props}
        ref={(el) =>
          typeof ref === "function" ? ref(el) : ref && (ref.current = el)
        }
      />
    );
  },
);

Toast.displayName = "Toast";

export default Toast;
